import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { log } from 'console';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Turnos } from 'src/app/models/dash';
import { CasetaService } from 'src/app/services/caseta.service';
import { ReporteriaService } from 'src/app/services/convenio/reporteria.service';
import { CorteService } from 'src/app/services/corte.service';
import { TurnoService } from 'src/app/services/turno.service';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';
@Component({
  selector: 'app-fallas',
  templateUrl: './fallas.component.html',
  styleUrls: ['./fallas.component.scss']
})

export class FallasComponent implements OnInit {

  tipoReporte = 1;
  casetas:any[]=Array();
  user: any;
  carriles:any[]=Array();
  corteForm = new FormGroup({
    caseta: new FormControl('', Validators.required),
    turno: new FormControl('', Validators.required),
    fecha: new FormControl(moment(new Date()).format('YYYY-MM-DD'), Validators.required),
    corte: new FormControl('', Validators.required),
    tipo: new FormControl(1, Validators.required),
  });

  turnos: Turnos[]=Array();
  cortes: any[]=Array();
  cortesUsed: any[]=Array();
  fallas: any;

  constructor(
    private corteService: CorteService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private store: Store<AppState>,
    private fb: FormBuilder,
    private toastr: ToastrService,
        private turnoService: TurnoService,
    private reporteriaServices:ReporteriaService) {
  }

  ngOnInit(): void {
    this.ngxUiLoaderService.start();
    this.store.select(selectUser).subscribe(user =>{
      this.user = user;
      this.corteForm.setValue({  caseta:this.user.caseta_usuario[0].id, fecha:moment(new Date()).format('YYYY-MM-DD'), tipo:1})
    });
    this.corteService.getCasetas().subscribe( casetas => {
      this.casetas = casetas;
      this.ngxUiLoaderService.stop();
    });

    this.turnoService.getTurnos().subscribe(turnos => {
      this.turnos = turnos;
    });

  }
  setTipoReporte(event:any){
    this.tipoReporte=event.target.value;
    this.corteForm.patchValue({tipo:this.tipoReporte,
      caseta:this.user.caseta_usuario[0].id,})
  }
  generarReporte(){
    this.ngxUiLoaderService.start();
    this.corteService.getCorteReporteFallas( this.corteForm.value ).subscribe( (fallas:any) => {
      this.fallas = fallas;
    });
    this.ngxUiLoaderService.stop();

  }

  getCarriles( event: any) {

    this.carriles = this.casetas.find(caseta => caseta.id == event.target.value).carriles;
  }
  buscarCortes(){
    this.fallas = null;
    let {tipo}=this.corteForm.value
    if(tipo==1){
      // buscar cortes
      let dataForm = this.corteForm.getRawValue();
      this.corteService.cortesPorFechaCasetaTurno(dataForm).subscribe(cortes => {
        if (!cortes.length) {
          return this.toastr.info(`No existen cortes para esta configuracion`, '', { positionClass: 'toast-bottom-right' })
        }
        this.cortes = cortes;
        let data = {fecha:this.corteForm.value.fecha ,id_jefe_turno: this.user.id}
        this.corteService.getCortesUsedJT(data).subscribe(data => {
          this.cortesUsed = data;
          this.ngxUiLoaderService.stop()
        })
      });
    }

  }
}
